<template>
  <div
    :class="{'row':isRow}"
    class="detail-container">
    <div class="empty" />
    <div
      v-for="(item,index) in newForm"
      :key="index">
      <p
        v-if="item.type==='title'"
        :class="{'first':item.isFirst}"
        class="title"
      >{{ item.label }}</p>
      <p
        v-if="item.type==='text'"
        class="text">{{ item.label?item.label+':':'' }} {{ item.value }}</p>
      <div
        v-else-if="item.type==='table'"
        class="table">
        <table
          border="1"
          borderColor="#f2f2f2"
        >
          <thead>
            <tr><td
              v-for="(item1,index1) in item.thead"
              :key="'th'+index1">{{ item1 }}</td></tr>
          </thead>
          <tbody>
            <tr
              v-for="(item2,index2) in item.value"
              :key="'tr'+index2">
              <td
                v-for="(item3,index3) in item2"
                :key="'td'+index3"><StateBox :value="item3"/></td>
            </tr>
          </tbody>
        </table>
      </div>
      <RowCell
        v-else-if="Object.prototype.toString.call(item) === '[object Array]'"
        :form="item"
        :is-row="true" />
    </div>
  </div>
</template>

<script>
import RowCell from "./components/RowCell.vue";
import StateBox from "./components/StateBox.vue";

export default {
name: "CourseDetail",
components: {
  RowCell,
  StateBox,
},
props: {
  form: [Array, Object],
  isRow: {
    type: Boolean,
    default: false,
  },
},
data() {
  return {
    newForm: this.form,
  };
},
watch: {
  form: {
    handler(vl) {
      this.newForm = vl;
    },
    deep: true,
    immediate: true,
  },
},
};
</script>

<style scoped>
.empty{
  width: 100%;
  height: 20px;
}
.detail-container{
  position: relative;
}
.row{
    display: flex;
    flex-direction: row;
}
.title,.text{
  line-height: 30px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.title{
  font-size: 16px;
  margin-top: 20px;
  line-height: 40px;
  color: #323232;
  font-weight: bold;
}
.title.first{
  margin-top: 0px;
}
.table table{
    width: 100%;
    border-collapse:collapse;
}
.table table td{
    line-height: 20px;
    padding: 6px;
}
</style>
